// @flow

import { all, takeLatest, select, call } from 'redux-saga/effects';
import clientConfig from '~/../parameters/client/config';
import ApiFeedback from '~/sdk/feedback/ApiFeedback';
import type { ApiSaveAnswersRequest } from '~/sdk/feedback/dtos/api-save-answers-request';
import { getVerticalId, getCountryCode } from '~/common/selectors/config';
import { getOrigin, installationIdSelector } from '~/common/selectors/trovit';
import formatISODate from '~/utils/formatISODate';
import type { SaveAnswersAction } from './types';
import { SAVE_ANSWERS } from './actionTypes';
import { convertToDto } from './answer-mapper';
import { userIdSelector } from '../user/selectors';
import { getBrowserId, getDevice } from '~/request/device/utils';

const feedbackApi = new ApiFeedback(clientConfig.feedbackApi);

export function* saveAnswersSaga({ payload: { answers } }: SaveAnswersAction): Generator<*, *, *> {
  const campaignId = '0fd86de6-89f9-4d7e-a20f-75d913aafadd';
  const verticalId = yield select(getVerticalId);
  const countryCode = yield select(getCountryCode);
  const userId = yield select(userIdSelector);

  if (!userId) {
    // Prevent error when userId does not exist
    return;
  }

  const installationId = yield select(installationIdSelector);
  const origin = yield select(getOrigin);
  const dateInsert = formatISODate(new Date());

  const deviceId = getDevice(window.navigator.userAgent);
  const browserId = getBrowserId(deviceId);

  const apiRequest: ApiSaveAnswersRequest = {
    campaignId,
    verticalId,
    countryCode,
    browserId,
    userId,
    cookieId: installationId,
    origin,
    dateInsert,
    answers: [].concat(answers).map(convertToDto),
  };

  try {
    yield call([feedbackApi, feedbackApi.saveAnswers], apiRequest);
  } catch (error) {
    // Ignore error
  }
}

export default function* feedbackSagas(): Generator<*, *, *> {
  yield all([takeLatest(SAVE_ANSWERS, saveAnswersSaga)]);
}



// WEBPACK FOOTER //
// ./app/CaptureFeedback/Form/sagas.js